{
  "name": "@ns/public-ledger-sign-mismatch",
  "version": "1.0.0",
  "description": "A signatory's browser refused to sign a public ledger transaction: what it was served didn't match what its card showed, so nothing was signed. The PUBLIC_LEDGER team finds out why, then marks it resolved. The card's metadata names the signing workflow, the company, the transaction, the reason code and who reported it; it carries no transaction bytes or keys.",
  "inputs": {},
  "outcomes": {
    "resolved": {}
  }
}
